import { withNamespaces } from "react-i18next";

import WhiteButton from "../form_components/Buttons/WhiteButton/WhiteButton";
import Select from "../form_components/Select/Select";

function BannerPanelEditBox({
  t,

  tableFilter,
  setTableFilter,

  useFetchRender,
  setUseFetchRender,

  handleOpenAddBannerModal,
}) {
  /* process => Yapılacak işlem (düzenle,sil,..) */
  function handleClick(process) {
    switch (process) {
      case "render":
        console.log("Tablo yenilendi!");

        setUseFetchRender(!useFetchRender);
        break;
      case "add":
        handleOpenAddBannerModal();

        break;

      default:
        break;
    }
  }

  const selectOptions = [
    { key: "", text: t("select_options_all") },
    { key: 1, text: t("select_options_waiting_approved") },
    { key: 2, text: t("select_options_active") },
    { key: 3, text: t("select_options_passive") },
  ];

  return (
    <div className="edit-container">
      <div className="edit-box">
        <>
          <div className="edit-container-title">
            <div className="title">
              <i className="fa-regular fa-images"></i>
              <h4 className="title">{t("banner_panel_title")}</h4>
            </div>
          </div>

          <div className="edit-container-button-group">
            <WhiteButton
              icon={<i className="fa-solid fa-arrow-rotate-right" />}
              tooltip={t("button_edit_render")}
              onClick={() => handleClick("render")}
            />

            <Select
              name="filter"
              options={selectOptions}
              select={tableFilter}
              setSelect={setTableFilter}
              className="select-filter-sort"
            />

            <WhiteButton
              icon={<i className="fa-solid fa-plus" />}
              tooltip={t("banner_panel_new_banner_button")}
              onClick={() => handleClick("add")}
              className="button-white-active"
            />
          </div>
        </>
      </div>
    </div>
  );
}

export default withNamespaces()(BannerPanelEditBox);
